namespace GeniuzPOS.InitialData {
    export interface PsSalesmanGroupForm {
        SalesmanGroup: Serenity.StringEditor;
        SalesmanGroupDesc: Serenity.StringEditor;
    }

    export class PsSalesmanGroupForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsSalesmanGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsSalesmanGroupForm.init)  {
                PsSalesmanGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsSalesmanGroupForm, [
                    'SalesmanGroup', w0,
                    'SalesmanGroupDesc', w0
                ]);
            }
        }
    }
}
